export const getFlatFolders = tree => {
  const reducer = (arr, elem) => arr.concat(elem.subFolders);
  return tree.reduce(reducer, tree);
}
